;
define("product_list_control_item.tpl", function(){});

